import { render } from "./QuicksightDashboard.vue?vue&type=template&id=275a78e4&ts=true"
import script from "./QuicksightDashboard.vue?vue&type=script&lang=ts"
export * from "./QuicksightDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__